// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tRS4","content":"styles_content__3TBiz"};